import { render, staticRenderFns } from "./jfWeb.vue?vue&type=template&id=3d2dd200&scoped=true&"
import script from "./jfWeb.vue?vue&type=script&lang=js&"
export * from "./jfWeb.vue?vue&type=script&lang=js&"
import style0 from "./jfWeb.vue?vue&type=style&index=0&id=3d2dd200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2dd200",
  null
  
)

export default component.exports